import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import makeData from "../Table/makeData";
import { dataSetTopFeed } from "../../constants/table";

export default function GlobalMarket() {
    const columns = React.useMemo(
        () => [
            {
                Header: "Detail",
                columns: [
                    {
                        Header: "No.",
                        accessor: "country",
                    },
                    {
                        Header: "Name",
                        accessor: "production",
                    },
                    {
                        Header: "Country",
                        accessor: "productionValue",
                        filter: "equals",
                    },
                    {
                        Header: "Volume (Million Tons/Yr.)",
                        accessor: "percentUtilize",
                    },
                    {
                        Header: "Share (%)",
                        accessor: "inUsed",
                        filter: "includes",
                    },
                ],
            },
        ],
        []
    );

    const columnsTopFeed = React.useMemo(
        () => [
            {
                Header: "Detail",
                columns: [
                    {
                        Header: "Rank",
                        accessor: "rank",
                    },
                    {
                        Header: "Annual Feed Production (x 1000 metric tons)",
                        accessor: "production",
                    },
                    {
                        Header: "Company",
                        accessor: "company",
                        filter: "equals",
                    },
                    {
                        Header: "Cpuntry",
                        accessor: "country",
                    },
                    {
                        Header: "Feed Mills",
                        accessor: "feed",
                        filter: "includes",
                    },
                ],
            },
        ],
        []
    );

    const dataSet = [
        {
            country: "ไทย",
            production: "7,150",
            productionValue: "5,755",
            percentUtilize: "80%",
            inUsed: "3,833",
        },
        {
            country: "เวียดนาม",
            production: "4,956",
            productionValue: "3,995",
            percentUtilize: "81%",
            inUsed: "2,733",
        },
        {
            country: "ตุรกี",
            production: "1,498",
            productionValue: "844",
            percentUtilize: "56%",
            inUsed: "94",
        },
        {
            country: "รัสเซีย",
            production: "1,416",
            productionValue: "1,202",
            percentUtilize: "85%",
            inUsed: "1,202",
        },
        {
            country: "เมียนม่า",
            production: "936",
            productionValue: "750",
            percentUtilize: "80%",
            inUsed: "379",
        },
        {
            country: "แคนาดา",
            production: "855",
            productionValue: "744",
            percentUtilize: "87%",
            inUsed: "744",
        },
        {
            country: "ไต้หวัน",
            production: "836",
            productionValue: "836",
            percentUtilize: "100%",
            inUsed: "319",
        },
        {
            country: "มาเลเซีย",
            production: "636",
            productionValue: "527",
            percentUtilize: "83%",
            inUsed: "222",
        },
        {
            country: "อินเดีย",
            production: "636",
            productionValue: "411",
            percentUtilize: "65%",
            inUsed: "133",
        },
        {
            country: "กัมพูชา",
            production: "630",
            productionValue: "643",
            percentUtilize: "102%",
            inUsed: "547",
        },
        {
            country: "ฟิลิปปินส์",
            production: "600",
            productionValue: "480",
            percentUtilize: "80%",
            inUsed: "402",
        },
        {
            country: "บังคลาเทศ",
            production: "480",
            productionValue: "425",
            percentUtilize: "88%",
            inUsed: "110",
        },
        {
            country: "โปแลนด์",
            production: "240",
            productionValue: "202",
            percentUtilize: "84%",
            inUsed: "202",
        },
        {
            country: "ลาว",
            production: "210",
            productionValue: "187",
            percentUtilize: "89%",
            inUsed: "127",
        },
        {
            country: "ปากีสถาน",
            production: "96",
            productionValue: "86",
            percentUtilize: "89%",
            inUsed: "11",
        },
    ];

    // const data = React.useMemo(() => makeData(100), []);
    const [data, setData] = React.useState(makeData(100));

    // React.useEffect(() => {
    //   setData(makeData(100));
    // }, []);
    const handleReset = () => {
        setData(makeData(100));
    };

    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    function Table({ columns, data }) {
        const props = useTable(
            {
                columns,
                data,
            },
            useGlobalFilter, // useGlobalFilter!
            usePagination
        );
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            rows,
            prepareRow,
            setGlobalFilter,
            state,
            page, // Instead of using 'rows', we'll use page,
            // which has only the rows for the active page

            // The rest of these things are super handy, too ;)
            canPreviousPage,
            canNextPage,
            pageOptions,
            pageCount,
            gotoPage,
            nextPage,
            previousPage,
            setPageSize,
            state: { pageIndex, pageSize, globalFilter },
        } = props;
        console.log(props);
        React.useEffect(() => {
            // props.dispatch({ type: actions.resetPage })
            console.log(globalFilter);
        }, [globalFilter]);

        return (
            <>
                {console.log(globalFilter)}
                <input
                    type="text"
                    value={globalFilter || ""}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                />
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr
                                style={{
                                    backgroundColor: "#003600",
                                    color: "white",
                                    fontSize: "24px",
                                }}
                                {...headerGroup.getHeaderGroupProps()}
                            >
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}>
                                        {column.render("Header")}
                                        {/* Render the columns filter UI */}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr
                                    style={{
                                        fontSize: "20px",
                                    }}
                                    {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => {
                                        return (
                                            <td style={{ backgroundColor: 'white' }} {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className="pagination">
                    <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        {"<<"}
                    </button>{" "}
                    <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                        {"<"}
                    </button>{" "}
                    <button onClick={() => nextPage()} disabled={!canNextPage}>
                        {">"}
                    </button>{" "}
                    <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        {">>"}
                    </button>{" "}
                    <span>
                        Page{" "}
                        <strong>
                            {pageIndex + 1} of {pageOptions.length}
                        </strong>{" "}
                    </span>
                    <span>
                        | Go to page:{" "}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                            }}
                            style={{ width: "100px" }}
                        />
                    </span>{" "}
                    <select
                        value={pageSize}
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                        }}
                    >
                        {[10, 20, 30, 40, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </div>

                <br />
                {/* <div>Showing the first 20 results of {rows.length} rows</div> */}
                <div>
                    <pre>
                        <code>{JSON.stringify(state.filters, null, 2)}</code>
                    </pre>
                </div>
            </>
        );
    }

    const globalFeedProduction = () => {
        return (
            <>
                <div className="geomap-powerbi">
                    <iframe title="Global Market" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=7a43e372-8f06-45a8-931b-7d99f6d1eff0&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095" frameborder="0" allowFullScreen="true"></iframe>
                </div>
                <div className="map-insight">
                    <div className="global-market-title">
                        ปริมาณความต้องการอาหารสัตว์โลก ปี 2021
                    </div>
                    <div className="global-market-desc-box">
                        <div className="global-market-desc-title">
                            รวมทั่วโลก
                        </div>
                        <div className="global-market-desc-box-grid-left">
                            <div className="global-market-feed-production-subtitle">ผลิต</div>
                            <div className="global-market-desc-number">1,236</div>
                            <div className="global-market-feed-production-subtitle">ล้านตัน</div>
                        </div>
                    </div>
                    <div className="cpf-world-wide-table-lib">
                        <button style={{ marginBottom: '10px' }} onClick={handleReset}>Reset Data</button>
                        <Table columns={columns} data={dataSet} />
                    </div>
                    <div className="global-market-title">
                        2021 Top Feed Companies
                    </div>
                    <div className="cpf-world-wide-table-lib">
                        <button style={{ marginBottom: '10px' }} onClick={handleReset}>Reset Data</button>
                        <Table columns={columnsTopFeed} data={dataSetTopFeed} />
                    </div>
                    {/* <table className="global-feed-production-table">
                        <tr>
                            <th>No.</th>
                            <th>Name</th>
                            <th>Country</th>
                            <th>Volume (Million Tons/Yr.)</th>
                            <th>Share (%)</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>CP Group</td>
                            <td>Thailand</td>
                            <td>34</td>
                            <td>3%</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>New Hope Group</td>
                            <td>China</td>
                            <td>28</td>
                            <td>2%</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Haid Group</td>
                            <td>China</td>
                            <td>20</td>
                            <td>2%</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Cargill</td>
                            <td>USA</td>
                            <td>20</td>
                            <td>2%</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Land O’Lake</td>
                            <td>USA</td>
                            <td>14</td>
                            <td>1%</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Others</td>
                            <td></td>
                            <td>1,120</td>
                            <td>90%</td>
                        </tr>
                    </table> */}
                </div>
            </>
        )

    }

    return (
        <div>
            <div className='navbar'>
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <div className="global-market-container">
                <div className="global-market-grid">
                    <Link className="global-market-menuitem" to="/global-market/global-feed-production">Global feed production</Link>
                    <Link className="global-market-menuitem" to="/global-market/cp-world-wide">CP World wide</Link>
                    <Link className="global-market-menuitem" to="/global-market/cpf-feed-production">CPF feed production</Link>
                </div>
                {globalFeedProduction()}
            </div>
        </div>
    );
}

